
export const isRequestingData = (state, resource) => {
    if (resource) return isRequestingResource(state, resource);
    let req = state.getIn(['session', 'requesting']);
    if (!req) return false;
    return req.count() > 0;
};

export const isRequestingResource = (state, resource) => (!!state.getIn(['session', 'requesting', resource]));

export const getFlashMessage = state => state.getIn(['session','flashMessage']);